module.exports = __webpack_public_path__ + "static/media/Colony-Farms-Subdivision-Plymouth-Restated-Sub-Agreement-ByLaws.10c44b1a.pdf";